<template>
    <div :class="`tour-backdrop ${isTourActive ? ' tour-backdrop-active' : ''}`" />
</template>

<script>
import { mapState } from 'pinia';
import { useContextStore } from '../../../stores/contextStore';
import { REDESIGN_TOUR_STEPS, useNavRedesignTourStore } from '../../../stores/navRedesignTourStore';
import { useVendorStatusStore } from '../../../stores/vendorStatusStore';

export default {
    name: 'TourBackdrop',
    computed: {
        ...mapState(useNavRedesignTourStore, ['tourStep']),
        ...mapState(useContextStore, ['isAuthorized']),
        ...mapState(useVendorStatusStore, ['isInSubmitted']),
        isTourActive() {
            return this.tourStep !== REDESIGN_TOUR_STEPS.TOUR_FINISHED && this.isAuthorized && !this.isInSubmitted;
        },
    },
};
</script>

<style lang="scss" scoped>
.tour-backdrop {
    display: none;

    &-active {
        display: unset;
        position: fixed;
        inset: 0;
        opacity: 0;
        z-index: $tour-backdrop-index;
    }
}
</style>
